import {
  postJSON,
  putJSON,
  deleteJSON,
  getJSON,
  patchJSON
} from "../../shared_component/utils/fetch"
import Notifications from "../components/Notifications"
import { getMembershipPlans } from "./membership"
import { setLanguage } from "../helpers/translationHelpers"
import i18n from "../../shared_component/utils/i18n"
import * as Sentry from "@sentry/react"
import { identifyEvent, trackEvent } from "../../shared_component/utils/segmentAnalytics"
import {
  getActiveVehicle,
  getTransformedMaintenanceScheduleResponse
} from "../helpers/vehicleHelpers"
import { getSignInOrSignUpMethod, getUserType, getVehicleProps } from "../helpers/segmentHelper"
import { getMaintenanceSchedules } from "./maintenanceSchedules"
import { has, isEmpty, isFunction } from "lodash"
import { FS_NAMESPACES } from "../constants/application"
import { COUNTRY_CODE } from "../../shared_component/utils/stringHelpers"
import {
  gaJSON,
  setFirebaseAnalyticsUserId,
  trackFirebaseAnalytics
} from "../../shared_component/utils/googleAnalyticsHelpers"
import store from "../../shared_component/utils/configureStore"
import { clearSession } from "../../shared_component/utils/sessionManagerHelper"
import SplitClient, { UBER_VALVOLINE, VALVOLINE_COMPANY_ID } from "../components/Config/SplitClient"
import { FIND_SHOPS_URL } from "./shop"
import { UBER_PARENT } from "../constants/affiliations"
import { OPEN_CART } from "../reducers/cart"
import { getSubdomain } from "../components/Config/StylesheetInjector"
import { EMAIL, OTP, PHONE, VERIFY_OTP } from "./otp-auth"
import { getCustomerPromotions } from "./promotion"
import { logOutKlaviyo } from "../helpers/klaviyoHelper"
import { setOrders } from "./orders"

const SIGN_UP_URL = "/api/v4/customers"
const VERIFY_RIDESHARE_INSPECTION_URL = "/api/v4/shopping_carts/verify_rideshare_inspection"
const ACTIVE_CARTS_URL = "/api/v4/shopping_carts"
const RESET_PASSWORD_URL = "/api/v4/customers/reset_password"
const SIGN_IN_URL = "/api/v4/customers/auth"
const VEHICLES_URL = "/api/v4/vehicles"
const VEHICLE_DETAILS_URL = (id) => `/api/v4/vehicles/${id}`
const CART_URL = "/api/v4/customers/?/shopping_cart"
const DELETE_CART_URL = "api/v4/shopping_carts"
const ME_URL = "/api/v4/customers/me"
const PRODUCT_UPDATE_ACKNOWLEDGEMENTS_URL = "/api/v4/product_update_acknowledgements"
const PREFERENCES_URL = (userId) => `/api/v4/customers/${userId}/maintenance_preferences`
const MAGIC_LINK_URL_V5 = "api/v6/users/search_by"
const RETAIL = "basic"
const MAGIC_LINK = "magic_link"
const ACTIVE_CART_URL = "api/v4/customers/active_carts"
const ACTIVE_ORDERS_URL = "api/v4/customers/orders"
const MEMBERSHIP_DETAILS_URL = "api/v4/memberships"
const AFFILIATION_DETAILS_URL = "api/v4/affiliations/me"
const CLOSED_ORDERS_URL = "api/v4/customers/orders?status=closed"
const ORDER_DETAILS_URL = (userId, orderId) => `/api/v4/customer/${userId}/order/${orderId}`
const RETAIL_DEFAULT_V2 = "retail_default_v2"

export const USER_LOADING = "USER_LOADING"

export function setUserLoading(msg) {
  return { type: USER_LOADING, loadingMessage: msg }
}

export const USER_NOT_LOADING = "USER_NOT_LOADING"

export function setUserNotLoading() {
  return { type: USER_NOT_LOADING }
}

export const USER_ERROR = "USER_ERROR"

export function setUserError(error) {
  return { type: USER_ERROR, error }
}

export const LOGOUT_USER = "LOGOUT_USER"
export const logoutUser = () => {
  let user = store.getState().user || {}
  logOutKlaviyo()
  clearSession()
  return {
    type: LOGOUT_USER
  }
}

export const IDENTIFY_AND_SET_USER = "IDENTIFY_AND_SET_USER"
export const UPDATE_USER_PREFERENCES = "UPDATE_USER_PREFERENCES"
export const SHOW_UBER_MEMBERSHIP_BENEFITS_MODAL = "SHOW_UBER_MEMBERSHIP_BENEFITS_MODAL"
export const SHOW_FUELCARD_MARKETING_MODAL = "SHOW_FUELCARD_MARKETING_MODAL"

// note: this isn't exported! should only be triggered via the calls to `setUserData` below
function setAndIdentifyUser(user, isCart) {
  return { type: IDENTIFY_AND_SET_USER, user, isCart }
}

function setAndUpdateUserPreferences(preferences) {
  return { type: UPDATE_USER_PREFERENCES, preferences }
}

// Store fuelcard modal value in redux state
export const setAndUpdateFuelcardModal = (flag) => {
  return { type: SHOW_FUELCARD_MARKETING_MODAL, paylod: flag }
}

export function setUserPreferences(preferences) {
  return async function (dispatch) {
    dispatch(setAndUpdateUserPreferences(preferences))
  }
}

export function setUserData(user, isCart = false) {
  return async function (dispatch) {
    dispatch(setAndIdentifyUser(user, isCart))
  }
}

export const REMOVE_USER = "REMOVE_USER"

export function removeUser() {
  return { type: REMOVE_USER, loading: false }
}

export const SET_ACTIVE_VEHICLE = "SET_ACTIVE_VEHICLE"

function setActiveVehicle(vehicleId) {
  return {
    type: SET_ACTIVE_VEHICLE,
    activeVehicleId: vehicleId,
    loading: false
  }
}

export const NEW_USER_STATUS = "NEW_USER_STATUS"

export function newUserStatus(status) {
  return { type: NEW_USER_STATUS, newUserStatus: status }
}

export const UPDATE_ACTIVE_ORDER = "UPDATE_ACTIVE_ORDER"

export function updateActiveOrder(order) {
  return { type: UPDATE_ACTIVE_ORDER, payload: order }
}

export const UPDATE_ACTIVE_CARTS = "UPDATE_ACTIVE_CARTS"

export function updateActiveCarts(carts) {
  return { type: UPDATE_ACTIVE_CARTS, payload: { shopping_carts: carts } }
}

export const LOAD_USER_STATES = "LOAD_USER_STATES"

export function loadUserStates(data) {
  return { type: LOAD_USER_STATES, payload: data }
}

export function updateActiveVehicle(vehicleId) {
  return function (dispatch, getState) {
    dispatch(setActiveVehicle(vehicleId))
    dispatch(addValvolineShopForUberDriver())
  }
}

export function setLoading(message) {
  return async function (dispatch) {
    dispatch(setUserLoading(message))
    return () => {}
  }
}

export function setNotLoading() {
  return async function (dispatch) {
    await dispatch(setUserNotLoading())
    return () => {}
  }
}

export const ME = "ME"

export function me(queryRequest = RETAIL) {
  return async function (dispatch, getState) {
    dispatch(setUserLoading())
    let user = getState().user || {}
    let { authentication_token } = user
    let url = `${ME_URL}`
    dispatch(fetchVehicles())
    dispatch(fetchActiveCart())
    dispatch(fetchActiveOrders())
    dispatch(fetchMembershipDetails())
    dispatch(fetchAffiliationDetails())
    dispatch(getCustomerPromotions())

    let response = await postJSON(
      url,
      { query: queryRequest },
      { Authorization: authentication_token } //this call will return data for user only with matching authentication id from backend.
    )
    if (response && response.result) {
      user.loading = false
      user.error = null
      let userData = {
        ...response.result,
        uses_membership: true
      }
      try {
        Sentry.setUser({
          id: userData.id,
          email: userData.email,
          username: `${user.firstName} ${user.lastName}`,
          language: userData.language,
          fleet_id: userData.fleet_id,
          affiliation_name: userData.affiliation_name,
          customer_number: userData.customerNumber
        })
      } catch (e) {
        console.error("UNABLE TO SET SENTRY USER DATA", e)
      }
      await dispatch(setUserData(userData))
      if (userData) setLanguage(userData.language, userData.country)
      setFirebaseAnalyticsUserId(user.id)
      dispatch(setActiveVehicleId())
    } else {
      if (response && response.error) dispatch(setUserError(response.error))
    }
    dispatch(setUserNotLoading())
    return () => response
  }
}

export const UPDATE_CART = "UPDATE_CART"

export function updateCart(events, vehicleId, interval_id, noLoad, opts = {}) {
  return async function (dispatch, getState) {
    if (!noLoad) dispatch(setUserLoading())
    let user = getState().user || {}

    const activeOrder =
      !isEmpty(user.active_orders) && user.active_orders.find((order) => order.id === opts.orderId)

    let { authentication_token } = user
    let url = `${CART_URL.replace("?", user.id)}`
    let payload
    if (Array.isArray(events)) {
      payload = {
        events: events,
        vehicle_id: vehicleId || user.activeVehicleId,
        interval_id: interval_id,
        update_existing_order: opts && opts.isOrder,
        shop_order_id: opts && opts.orderId
      }
    } else {
      //prepay
      payload = {
        opted_for_prepayment: events,
        vehicle_id: vehicleId || user.activeVehicleId,
        interval_id: interval_id,
        update_existing_order: opts && opts.isOrder,
        shop_order_id: opts && opts.orderId
      }
    }
    if (opts.promoCode) payload["promo_code"] = opts.promoCode
    if (opts.redeem_miles) payload["reward_miles"] = +opts.redeem_miles
    let response = await putJSON(url, payload, { Authorization: authentication_token })
    //this will also return prepay discount and total,subtotal ,taxes and fees according to prepay
    //prepay_discount--prepay dsicount
    //estimated_total_prepay- estimated total with prepay discount applied
    //estimated_total_pre_tax_prepay- subtotal  with prepay discount applied

    if (response.result) {
      user.loading = false
      user.error = null
      if (!user.active_carts) user.active_carts = []
      let spliceIndex = user.active_carts.findIndex(
        (c) => c.vehicle_id === response.result.vehicle_id
      )
      if (spliceIndex !== -1) user.active_carts.splice(spliceIndex, 1)
      user.active_carts.push(response.result) //here we will push all the data in the active carts which will be new cart
      await dispatch(setUserData(user, true)) //here user will be updated with new user data having
      // active carts updated.
      if (opts.successCallback) opts.successCallback(response.result)
    } else {
      dispatch(
        Notifications.error({
          title: i18n.t("common:notificationErrorTitle"),
          message: `${response.error}`,
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
      dispatch(setUserError(response.error))
    }
    if (opts.callback) opts.callback()
    return () => response
  }
}

export function storeUser(user) {
  return function (dispatch) {
    dispatch(setUserData(user))
  }
}

export function deleteCart(cartId) {
  return async function (dispatch, getState) {
    dispatch(setUserLoading())
    let user = getState().user || {}

    let { authentication_token } = user
    let url = `${DELETE_CART_URL}/${cartId}`

    let response = await deleteJSON(url, {}, { Authorization: authentication_token })

    if (response.result) {
      user.loading = false
      user.error = null
      if (!user.active_carts) user.active_carts = []
      let spliceIndex = user.active_carts.findIndex((c) => c.vehicle_id === user.activeVehicleId)
      if (spliceIndex !== -1) user.active_carts.splice(spliceIndex, 1)
      await dispatch(setUserData(user))
    } else {
      dispatch(
        Notifications.error({
          title: i18n.t("common:notificationErrorTitle"),
          message: response?.error ? `${response.error}` : "Cart deletion failed",
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
      dispatch(setUserError(response.error))
    }
    return () => response
  }
}

export function addNewVehicle(data, savePartial = false) {
  return async function (dispatch, getState) {
    dispatch(setUserLoading())

    let user = getState().user || {}
    let { authentication_token } = user
    let url = savePartial ? `${VEHICLES_URL}?save=partial` : `${VEHICLES_URL}`
    let response = await postJSON(url, { vehicle: data }, { Authorization: authentication_token })

    if (response.result) {
      user.loading = false
      user.error = null
      let vehicle = response.result.vehicle

      if (savePartial) {
        localStorage.setItem("lastActiveVehicleId", user.activeVehicleId)
      } else {
        user.vehicles.push(vehicle)
      }
      user.activeVehicleId = vehicle.id
      dispatch(setUserData(user))
      dispatch(setActiveVehicle(vehicle.id))

      if (user.active_carts && user.active_carts.find((cart) => cart.vehicle_id === null)) {
        const request = {
          url: ACTIVE_CARTS_URL,
          headers: { Authorization: authentication_token },
          body: {}
        }
        const activeCartsResponse = await getJSON(request.url, request.body, request.headers)

        if (activeCartsResponse.result) {
          dispatch(updateActiveCarts(activeCartsResponse.result))
        } else {
          dispatch(
            Notifications.error({
              title: i18n.t("common:notificationErrorTitle"),
              message: i18n.t("user:cartUpdateFailedMessage")
            })
          )
        }
      }
      if (!has(vehicle, "maintenanceSchedules[0]")) {
        const maintenanceScheduleResponse = await dispatch(
          getMaintenanceSchedules({ vehicle: vehicle })
        )
        vehicle.maintenanceSchedules = getTransformedMaintenanceScheduleResponse(
          maintenanceScheduleResponse
        )
      }
      await identifyEvent({
        traits: getVehicleProps(vehicle),
        replaceUndefinedOrNullValues: false
      })
      trackFirebaseAnalytics({
        event: gaJSON.vehicle_added,
        params: {
          ...getVehicleProps(vehicle, { shouldAddCarsAdded: false }),
          methodToAddVehicle: "Manually",
          duringOnboarding: !data.isNewUser ? "No" : "Yes",
          flow: savePartial ? "PriceCompare" : ""
        }
      })
      trackEvent("vehicle-added", {
        ...getVehicleProps(vehicle, { shouldAddCarsAdded: false }),
        methodToAddVehicle: "Manually",
        duringOnboarding: !data.isNewUser ? "No" : "Yes"
      })
    } else {
      dispatch(
        Notifications.error({
          title: i18n.t("common:notificationErrorTitle"),
          message: response.error
        })
      )
      dispatch(setUserError(response.error))

      return false
    }

    return true
  }
}

export function updateVehicle(updatedVehicle) {
  return async function (dispatch, getState) {
    let user = getState().user || {}
    let updatedVehicleId = updatedVehicle.id

    const vehicles = user.vehicles.map((vehicle) => {
      return vehicle.id === updatedVehicleId ? { ...vehicle, ...updatedVehicle } : vehicle
    })

    dispatch(setUserData({ ...user, vehicles: vehicles }))

    return () => true
  }
}

export function deleteVehicle(vehicleId) {
  return async function (dispatch, getState) {
    dispatch(setUserLoading())

    let user = getState().user || {}
    let { authentication_token } = user
    let url = `${VEHICLES_URL}/${vehicleId}`
    let response = await deleteJSON(url, {}, { Authorization: authentication_token })

    if (response.result) {
      user.loading = false
      user.error = null
      const vehicleIndex = user.vehicles.findIndex((v) => v.id === vehicleId)
      user.vehicles.splice(vehicleIndex, 1)
      dispatch(setUserData(user))
    } else {
      dispatch(setUserError(response.error))
    }
  }
}

export function signUp(data) {
  return async function (dispatch) {
    dispatch(setUserLoading())

    let response = await postJSON(SIGN_UP_URL, data)
    if (response.result) {
      let user = response.result.user
      setFirebaseAnalyticsUserId(user.id)
      await dispatch(setUserData(user))
      dispatch(getCustomerPromotions())
      trackFirebaseAnalytics({
        event: gaJSON.sign_up,
        params: {
          // [gaJSON.email]: user.email,
          [gaJSON.first_name]: user.firstName,
          [gaJSON.last_name]: user.lastName,
          [gaJSON.zip]: parseInt(user.zip),
          [gaJSON.phone]: COUNTRY_CODE.concat(user.cellPhone)
        }
      })
      logOutKlaviyo()
      identifyEvent({
        traits: {
          firstNameWithSpace: user.firstName,
          lastNameWithSpace: user.lastName,
          phone: COUNTRY_CODE.concat(user.cellPhone),
          zip: user.zip,
          email: user.email
        },
        userId: user.id
      })
    } else {
      dispatch(setUserError(response.error))
    }
    return () => response
  }
}

export function signIn({
  email,
  password,
  key,
  vehicleId,
  isFromNoVehicle,
  isFullStoryFlagEnabled,
  otp, // Added OTP parameter
  otpType, // Added type (EMAIL or PHONE)
  otpTypeValue, // Added value for email/phone
  isOtpVerification = false, // Flag to differentiate between OTP and email-password sign-in
  callback
}) {
  return async function (dispatch) {
    let minimal = true,
      signedIn = false

    // Determine API endpoint and payload based on the type of login
    const url = isOtpVerification
      ? VERIFY_OTP
      : `${SIGN_IN_URL}?switch_to_user_affiliation_domain=true`
    const apiPayload = isOtpVerification
      ? {
          otp,
          [otpType === EMAIL ? EMAIL : PHONE]: otpTypeValue,
          client: "retail_web"
        }
      : {
          key,
          email,
          password,
          query: RETAIL_DEFAULT_V2,
          client: "retail_web"
        }

    const response = await postJSON(url, apiPayload, {})

    if (response.result) {
      const { result } = response
      let activeVehicleId = null

      if (vehicleId) {
        activeVehicleId = vehicleId
      }

      await dispatch(
        setUserData({
          ...result,
          activeVehicleId
        })
      )

      await dispatch(me())

      if (result.language) setLanguage(result.language, result.country)
      await dispatch(newUserStatus(false))
      await dispatch(getMembershipPlans())

      const activeVehicle = getActiveVehicle()
      signedIn = true
      sessionStorage.setItem("vehicle_list_modal_show", true)

      if (isFullStoryFlagEnabled) {
        // Identify user
        const user = {
          id: result.id,
          email: result.email,
          displayName: result.firstName + " " + result.lastName,
          firstName: result.firstName,
          lastName: result.lastName,
          phone: COUNTRY_CODE.concat(result.cellPhone),
          zip: result.zip,
          affiliation: result.affiliation_name
        }
        window[FS_NAMESPACES].identify(user.id, user)
        // window[FS_NAMESPACES].setUserVars(user.id, user)
      }

      identifyEvent({
        traits: {
          ...getVehicleProps(activeVehicle || {}, {
            shouldAddCarsAdded: false,
            omitIsDefault: true
          }),
          email: result.email,
          signInMethod: isOtpVerification
            ? OTP
            : getSignInOrSignUpMethod("signin", response.result.base_url, key),
          userType: getUserType(response.result.base_url),
          affiliation: result.affiliation_name,
          firstNameWithSpace: result.firstName,
          lastNameWithSpace: result.lastName,
          phone: COUNTRY_CODE.concat(result.cellPhone),
          zip: result.zip
        },
        userId: result.id,
        onSuccess: () => {
          trackFirebaseAnalytics({
            event: gaJSON.sign_in,
            params: {
              [gaJSON.first_name]: result.firstName,
              [gaJSON.last_name]: result.lastName,
              [gaJSON.zip]: parseInt(result.zip),
              [gaJSON.phone]: COUNTRY_CODE.concat(result.cellPhone),
              [gaJSON.affiliation]: result.affiliation_name,
              [gaJSON.user_type]: getUserType(response.result.base_url),
              [gaJSON.sign_in_method]: isOtpVerification
                ? OTP
                : getSignInOrSignUpMethod("signin", response.result.base_url, key)
            }
          })
          trackEvent("logged-in", {
            email: result.email,
            signInMethod: getSignInOrSignUpMethod("signin", response.result.base_url, key),
            userType: getUserType(response.result.base_url),
            affiliation: result.affiliation_name,
            firstNameWithSpace: result.firstName,
            lastNameWithSpace: result.lastName,
            phone: COUNTRY_CODE.concat(result.cellPhone),
            zip: parseInt(result.zip),
            didUserSignedFromNoVehicle: isFromNoVehicle ? "Yes" : "No"
          })
        }
      })
    } else {
      dispatch(
        Notifications.error({
          title: i18n.t("common:notificationErrorTitle"),
          message: response.error
        })
      )
      isFunction(callback) && callback("failure", { message: response.error })
      dispatch(setUserError(response.error))
    }

    return signedIn
  }
}

export function signOut() {
  return async function (dispatch, getState) {
    dispatch(setUserLoading())

    // let { authentication_token } = getState().user || {};
    // let response = await deleteJSON(SIGN_OUT_URL, { authentication_token });

    // if (response.error) {
    //   dispatch(setUserError(response.error));
    // } else {
    dispatch(removeUser())
    // }
  }
}

export function updateInfo(data) {
  return async function (dispatch, getState) {
    dispatch(setUserLoading())
    const user = getState().user || {}
    const url = `${SIGN_UP_URL}/${user.id}`
    const response = await putJSON(
      url,
      { ...data, serialize_basic: true },
      { Authorization: user.authentication_token }
    )
    if (response?.result) {
      const userResult = response.result.user || response.result || {}
      dispatch(setUserData({ ...user, ...userResult }))
      if (userResult) setLanguage(userResult.language, userResult.country)
      if (data.miles) dispatch(updateActiveVehicleInfo({ miles: data.miles }))
      if (data.displayNotification) {
        dispatch(
          Notifications.success({
            title: i18n.t("common:notificationSuccessTitle"),
            message: i18n.t("user:userUpdatedMessage")
          })
        )
      }
      // if (data.zip) dispatch(addValvolineShopForUberDriver())
      return true
    } else {
      const error = response.error || response.errors
      dispatch(setUserError(error))

      if (data.displayNotification || data.displayErrorNotification) {
        dispatch(
          Notifications.error({
            title: i18n.t("common:notificationErrorTitle"),
            message: `${error}`
          })
        )
      }
      return error
    }
  }
}

export function verifyRideshareInspection(data) {
  return async function (dispatch, getState) {
    const user = getState().user || {}
    const response = await postJSON(
      VERIFY_RIDESHARE_INSPECTION_URL,
      { shopping_cart_id: data.cartId },
      { Authorization: user.authentication_token }
    )

    const { result } = response
    if (result) {
      dispatch(updateActiveCarts(result.carts))
      return { success: true, serviceName: (result.service_definition || {}).name }
    } else {
      return { failure: true }
    }
  }
}

export function resetPassword(data) {
  return async function (dispatch, getState) {
    const user = getState().user || {}
    const response = await putJSON(RESET_PASSWORD_URL, data, {
      Authorization: user.authentication_token
    })
    // if the password is updated, it will redirect to signIn.  otherwise it will throw an error and redirect to forgot password
    return response
  }
}

export function acknowledgeProductUpdate(data) {
  return async function (dispatch, getState) {
    const user = getState().user || {}
    const response = await postJSON(PRODUCT_UPDATE_ACKNOWLEDGEMENTS_URL, data, {
      Authorization: user.authentication_token
    })
    // POST to create a ProductUpdateAcknowledgement on the user's behalf. They won't be shown this update again.
    return response
  }
}

export function updateActiveVehicleInfo(data) {
  return async function (dispatch, getState) {
    dispatch(setUserLoading())

    const user = getState().user || {}
    const { authentication_token, activeVehicleId } = user
    const url = `${VEHICLES_URL}/${activeVehicleId}`
    const response = await putJSON(url, data, { Authorization: authentication_token })

    if (response.result) {
      const activeVehicleIndex = user.vehicles.findIndex((v) => v.id === activeVehicleId)
      user.loading = false
      user.error = null
      user.vehicles.splice(activeVehicleIndex, 1, response.result.vehicle)

      dispatch(setUserData(user))
    } else {
      dispatch(setUserError(response.error))
    }
  }
}

export function fetchUserStates(payload) {
  return async function (dispatch, getState) {
    await dispatch(setLoading())
    let user = getState().user || {}
    let { authentication_token, country } = user
    if (authentication_token) {
      let request = {
        headers: { Authorization: authentication_token }
      }

      let response = await getJSON(`/api/v4/states?country=${country}`, {}, request.headers)

      if (response.result) {
        dispatch(loadUserStates(response.result))
      } else {
        if (payload?.callback) {
          payload.callback("failure", { message: response.error })
        }
      }
      dispatch(setNotLoading())
      return () => response
    }
  }
}

export function getUserDetails(payload) {
  return async function (dispatch, getState) {
    let user = getState().user || {}
    let { authentication_token, activeVehicleId } = user
    if (authentication_token) {
      let request = {
        headers: { Authorization: authentication_token }
      }

      let response = await getJSON(
        `${process.env.REACT_APP_INTERNAL_API_URL}/api/ecosystem/v1/user`,
        { vehicle_id: activeVehicleId },
        request.headers
      )

      if (response.result) {
        dispatch(loadUserStates(response.result))
      } else {
        payload.callback && payload.callback("failure", { message: response.error })
      }
      dispatch(setNotLoading())
      return response
    }
  }
}

export function updateUserDetails(payload, data) {
  return async function (dispatch, getState) {
    let user = getState().user || {}
    let { authentication_token } = user
    if (authentication_token) {
      let request = {
        headers: { Authorization: authentication_token }
      }
      const data = {
        vehicle_id: payload.vehicle_id,
        zip: payload.zip,
        mileage: payload.mileage,
        vin: payload.vin,
        language: payload.language
      }

      let response = await patchJSON(
        `${process.env.REACT_APP_INTERNAL_API_URL}/api/ecosystem/v1/user`,
        data,
        request.headers
      )

      if (response.result) {
        dispatch(loadUserStates(response.result))
      } else {
        payload.callback && payload.callback("failure", { message: response.error })
      }
      dispatch(setNotLoading())
      return response
    }
  }
}

export function updatePreferences(data) {
  return async function (dispatch, getState) {
    dispatch(setUserLoading())
    const user = getState().user || {}
    const { id, authentication_token } = user
    const url = PREFERENCES_URL(id)
    try {
      const headers = { Authorization: authentication_token }
      const response = await getJSON(url, data, headers)

      if (response.result) {
        dispatch(setUserPreferences(response.result))
        return response
      } else {
        const error = response.error || response.errors
        dispatch(setUserError(error))
        return error
      }
    } catch (e) {
      dispatch(setUserError(e))
      return e
    }
  }
}

export function getSplitIOForFeatures(payload) {
  return async function (dispatch, getState) {
    let user = getState().user || {}
    let { authentication_token } = user
    if (authentication_token) {
      let request = {
        headers: { Authorization: authentication_token }
      }

      let response = await getJSON(
        `${process.env.REACT_APP_INTERNAL_API_URL}/api/ecosystem/v1/providers/check_feature_flag?type=${payload}`,
        {},
        request.headers
      )

      if (response.result) {
        dispatch(loadUserStates(response.result))
      } else {
        payload.callback && payload.callback("failure", { message: response.error })
      }
      dispatch(setNotLoading())
      return response
    }
  }
}

export function getLogo(payload) {
  return async function (dispatch, getState) {
    let user = getState().user || {}
    let { authentication_token } = user
    if (authentication_token) {
      let request = {
        headers: { Authorization: authentication_token }
      }

      let response = await getJSON(
        `${process.env.REACT_APP_INTERNAL_API_URL}/api/ecosystem/v1/providers/logo?provider_names=["axiom", "forever", "zebra", "clearcover", "root"]`,
        {},
        request.headers
      )

      if (response.result) {
        dispatch(loadUserStates(response.result))
      } else {
        payload.callback && payload.callback("failure", { message: response.error })
      }
      dispatch(setNotLoading())
      return response
    }
  }
}

export function sendMagicLink(payload) {
  return async function (dispatch, getState) {
    const { data } = payload
    let request = {
      body: {
        type: data.type,
        value: data.value,
        source: "web"
      }
    }

    let response = await getJSON(MAGIC_LINK_URL_V5, request.body, {})

    dispatch(setNotLoading())
    return response
  }
}

export function signInViaMagicLink({ key, vehicleId, isFullStoryFlagEnabled }) {
  return async function (dispatch) {
    dispatch(setUserLoading())
    let signedIn = false
    let response = await postJSON(SIGN_IN_URL, {
      key,
      query: RETAIL_DEFAULT_V2,
      method: MAGIC_LINK
    })
    if (response.result) {
      const { result } = response
      setFirebaseAnalyticsUserId(result.id)
      let activeVehicleId = null

      if (vehicleId) {
        activeVehicleId = vehicleId
      }

      await dispatch(
        setUserData({
          ...result,
          activeVehicleId
        })
      )
      await dispatch(me())
      trackFirebaseAnalytics({
        event: gaJSON.sign_in,
        params: {
          // [gaJSON.email]: result.email,
          [gaJSON.first_name]: result.firstName,
          [gaJSON.last_name]: result.lastName,
          [gaJSON.zip]: parseInt(result.zip),
          [gaJSON.phone]: COUNTRY_CODE.concat(result.cellPhone),
          [gaJSON.affiliation]: result.affiliation_name,
          [gaJSON.user_type]: getUserType(response.result.base_url),
          [gaJSON.sign_in_method]: "Magic Link"
        }
      })
      if (result.language) setLanguage(result.language, result.country)
      await dispatch(newUserStatus(false))
      await dispatch(getMembershipPlans())
      signedIn = true
      sessionStorage.setItem("vehicle_list_modal_show", true)
      if (isFullStoryFlagEnabled) {
        // Identify user
        const user = {
          id: result.id,
          email: result.email,
          displayName: result.firstName + " " + result.lastName,
          firstName: result.firstName,
          lastName: result.lastName,
          phone: COUNTRY_CODE.concat(result.cellPhone),
          zip: result.zip,
          affiliation: result.affiliation_name
        }
        window[FS_NAMESPACES].identify(user.id, user)
      }
    } else {
      dispatch(setUserError(response.error))
    }
    dispatch(setUserNotLoading())
    return response
  }
}

export const validServicesForValvoline = ["oil_change", "courtesy_check"]

export function addValvolineShopForUberDriver() {
  return async function (dispatch, getState) {
    const { user } = getState()

    if (
      !user.activeVehicleId ||
      !user?.active_carts?.length ||
      user?.affiliation?.parent_name !== UBER_PARENT
    )
      return

    const activeCart = user.active_carts?.find((cart) => cart.vehicle_id === user.activeVehicleId)
    if (activeCart?.order_services.length !== validServicesForValvoline.length) return

    const treatment = await SplitClient.getTreatments([VALVOLINE_COMPANY_ID, UBER_VALVOLINE], user)

    if (treatment[UBER_VALVOLINE] === "off") return

    // Change shop if the current shop is Valvoline (Zip code change scenario) or if the shop is not selected
    const shouldChangeShop = activeCart.shop
      ? activeCart.shop.company_id === parseInt(treatment[VALVOLINE_COMPANY_ID])
      : true
    if (!shouldChangeShop) return

    const servicesRequested = activeCart.order_services.reduce((acc, service) => {
      if (validServicesForValvoline.includes(service.reference_id)) {
        acc.push({
          position: service.position,
          service_definition_id: service.service_definition_id
        })
      }
      return acc
    }, [])

    // Proceed only if all services are valid
    if (servicesRequested.length !== 2) return

    const params = {
      services_requested: JSON.stringify(servicesRequested),
      vehicle_id: activeCart.vehicle_id,
      zip: user.zip || 60606
    }

    const response = await getJSON(FIND_SHOPS_URL, params, {
      Authorization: user.authentication_token
    })

    if (response.result && !response.result.errors) {
      const valvolineShops = response.result
        .filter((shop) => shop.company_id === parseInt(treatment[VALVOLINE_COMPANY_ID]))
        .sort((a, b) => a.distance - b.distance)

      if (!valvolineShops.length) return

      dispatch(
        updateCart(
          [{ event: "set_shop", shop_id: valvolineShops[0].id }],
          undefined,
          undefined,
          true
        )
      )
    }
  }
}

export function closeUberMembershipBenefitsModal() {
  return async function (dispatch, getState) {
    const { user } = getState()

    dispatch({
      type: SHOW_UBER_MEMBERSHIP_BENEFITS_MODAL,
      payload: false
    })

    //Open mini cart only for Uber, skip Uber Canada
    if (user.affiliation.parent_name === UBER_PARENT) {
      dispatch({ type: OPEN_CART })
    }

    postJSON(
      `/api/v6/affiliations/${user.affiliation.parent_id}/user_promotions`,
      {
        show_membership_benefits: false
      },
      {
        Authorization: user.authentication_token
      }
    )
  }
}

export function fetchVehicles() {
  return async function (dispatch, getState) {
    const { user } = getState()
    let vehicles = await getJSON(VEHICLES_URL, {}, { Authorization: user.authentication_token })
    // user.vehicles = vehicles.result.map((v, i) => Object.assign({}, v, user.vehicles ? user.vehicles[i]: {}))
    vehicles =
      vehicles?.result
        ?.filter((vehicle) => vehicle?.owner_roles)
        ?.map((item) => {
          const obj = user?.vehicles ? user.vehicles.find((o) => o.id === item.id) : {}
          return { ...obj, ...item }
        }) || []
    await dispatch(setUserData({ vehicles }))
    dispatch(setActiveVehicleId())
    dispatch(fetchVehicleDetails())
  }
}

export function fetchActiveCart() {
  return async function (dispatch, getState) {
    const { user } = getState()
    const carts = await getJSON(ACTIVE_CART_URL, {}, { Authorization: user.authentication_token })
    const active_carts = carts?.result?.active_carts || []
    await dispatch(setUserData({ active_carts }, true))
    dispatch(setActiveVehicleId())
  }
}

export function fetchActiveOrders() {
  return async function (dispatch, getState) {
    const { user } = getState()
    const orders = await getJSON(
      ACTIVE_ORDERS_URL,
      {},
      { Authorization: user.authentication_token }
    )
    user.active_orders = orders.result
    dispatch(setUserData(user))
    dispatch(setOrders(orders.result || []))
  }
}

export function fetchAffiliationDetails() {
  return async function (dispatch, getState) {
    const { user } = getState()
    const affiliation = await getJSON(
      AFFILIATION_DETAILS_URL,
      {},
      { Authorization: user.authentication_token }
    )
    user.affiliation = affiliation.result
    user.affiliation_name = user?.affiliation?.name
    user.potential_product_update = user?.affiliation?.potential_product_update
    await dispatch(setUserData(user))
    dispatch(addValvolineShopForUberDriver())
  }
}

export function fetchVehicleDetails(id) {
  return async function (dispatch, getState) {
    const { user } = getState()
    const vehicle = await getJSON(
      VEHICLE_DETAILS_URL(id || user.activeVehicleId),
      {},
      { Authorization: user.authentication_token }
    )
    user.vehicles = user.vehicles?.map((v) => {
      if (v.id === (id || user.activeVehicleId)) {
        vehicle.result.details = true
        vehicle.result.oemServices = v.oemServices
        return vehicle.result
      } else return v
    })
    dispatch(setUserData(user))
  }
}

export function fetchMembershipDetails() {
  return async function (dispatch, getState) {
    const { user } = getState()
    const membership = await getJSON(
      MEMBERSHIP_DETAILS_URL,
      {},
      { Authorization: user.authentication_token }
    )
    user.membership = membership.result
    dispatch(setUserData(user))
  }
}

export function fetchClosedOrders() {
  return async function (dispatch, getState) {
    const { user } = getState()
    const closedOrders = await getJSON(
      CLOSED_ORDERS_URL,
      {},
      { Authorization: user.authentication_token }
    )
    user.closed_orders = []
    closedOrders.result.forEach((order) => {
      dispatch(fetchClosedOrderDetails(user.id, order.id))
    })
    dispatch(setUserData(user))
  }
}

export function fetchClosedOrderDetails(userId, orderId) {
  return async function (dispatch, getState) {
    const { user } = getState()
    const closedOrders = await getJSON(
      ORDER_DETAILS_URL(userId, orderId),
      {},
      { Authorization: user.authentication_token }
    )
    user.closed_orders.push(closedOrders.result)
    dispatch(setUserData(user))
  }
}

export function setActiveVehicleId() {
  return async function (dispatch, getState) {
    const { user } = getState()
    const cartWithVehicleIOwn = user.active_carts && user.active_carts[0]

    if (!user.activeVehicleId) {
      if (cartWithVehicleIOwn) {
        user.activeVehicleId = cartWithVehicleIOwn.vehicle_id
      } else if (user.vehicles && user.vehicles[0]) {
        user.activeVehicleId = user.vehicles[0].id
      }
    }
    dispatch(setUserData(user))
  }
}

export function setLastActiveVehicleId(vehicleId) {
  return async function (dispatch, getState) {
    const { user } = getState()
    if (vehicleId && user.vehicles.length > 0) {
      user.activeVehicleId = vehicleId
    } else if (user.vehicles && user.vehicles[0]) {
      user.activeVehicleId = user.vehicles[0].id
    }
    dispatch(setUserData(user))
  }
}

export function optInForMarketing(payload) {
  return async function (dispatch, getState) {
    let { user } = getState()
    let { authentication_token } = user

    if (authentication_token) {
      try {
        const response = await patchJSON(
          `/api/v6/retail/customers`,
          {
            customers: {
              marketing_opt_in: payload.marketing_opt_in
            }
          },
          { Authorization: authentication_token }
        )

        if (response.result) {
          user.marketing_opt_in = response.result?.marketing_opt_in || false
          await dispatch(setUserData(user))
          if (payload.closeModal) {
            payload.closeModal()
          }
          return response
        } else {
          const error = response.error || response.errors
          return { error }
        }
      } catch (error) {
        return { error: error.message }
      }
    }
  }
}
